module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"excerpt":"Put recipe here","id":"/Applications/MAMP/htdocs/falkens-party-supplies/src/pages/blog-posts/non-stick-recipe.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Non-Stick Cookie Dough Recipe","image":"/images/ssl.jpg","date":"July 12, 2017","path":"/blog/non-stick-cookie-dough-recipe"}}}]}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/blog.json
// module id = 346
// module chunks = 49683490770531